var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { config } from '../../../../../config/config';
import { MatFieldComponent } from '../../../../common/components';
import { FacebookLoginButtonComponent } from '../../../../common/components/facebook.login.button/facebook.login.button.component';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { EventTimeService } from '../../../../services/event.time.service';
import { ImageService } from '../../../../services/image.service';
import { PlaceService } from '../../../../services/place.service';
import { SeoService } from '../../../../services/seo.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { BaseComponent } from '../../../../common/components/base.component';
import { MatDialogRef, MatMenuTrigger } from '@angular/material';
import { AllFrontendSettingsStore, VisitorTripNotifyAddOrRemoveItemStore, VisitorTripStore, } from '../../../../stores/visitor.calendar.store';
import { TripDetailModalActions, TripDetailModalData } from './trip.detail.modal.provider';
import { ImageComponent } from '../../../../common/components/image/image.component';
import { ImageViewerComponent } from '../../../../common/components/image.viewer/image.viewer.component';
import { Location } from '@angular/common';
import { ShowInfoModalComponent } from '../../../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../../../hub/show.info.modal/show.info.modal.provider';
import { ModalService } from '../../../../common/services/modal.service';
import { DomSanitizer } from '@angular/platform-browser';
var TripDetailModalComponent = /** @class */ (function (_super) {
    __extends(TripDetailModalComponent, _super);
    function TripDetailModalComponent(dialogRef, activatedRoute, modalService, actions, formBuilder, imageService, location, allFrontendSettingsStore, visitorTripStore, notifyAddOrRemoveItemStore, visitorApiService, sanitizer, data) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.dialogRef = dialogRef;
        _this.activatedRoute = activatedRoute;
        _this.modalService = modalService;
        _this.actions = actions;
        _this.formBuilder = formBuilder;
        _this.imageService = imageService;
        _this.location = location;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.visitorTripStore = visitorTripStore;
        _this.notifyAddOrRemoveItemStore = notifyAddOrRemoveItemStore;
        _this.visitorApiService = visitorApiService;
        _this.sanitizer = sanitizer;
        _this.isFBFeedLoaded = false;
        _this.isGoogleFeedLoaded = false;
        _this.isAccommodation = false;
        _this.fbLogo = config.fbLogo;
        _this.isGooglePlaceMatchedWithFBPlace = false;
        _this.isNotInitLoginStatusChanged = false;
        _this.NoFeed = false;
        _this.userSelectedToViewFeed = false;
        _this.isShowFacebookFeed = false;
        _this.isShowGoogleFeed = false;
        _this.isShowNearbyPlaces = false;
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.placeSource = 'facebook';
        _this.detailDate = null;
        _this.detailTime = null;
        _this.isMultiDateEvent = false;
        _this.trancatedEventTimes = [];
        _this.trancatedEventTimesText = [];
        _this.facebookLogo = config.facebook.logo;
        _this.placePhotos = [];
        _this.placeImagesShownCount = 5;
        _this.onAddToTrip = new EventEmitter();
        _this.onRemoveFromTrip = new EventEmitter();
        _this.onAddNewTrip = new EventEmitter();
        _this.onAddFirstTrip = new EventEmitter();
        _this.data = Object.assign({}, data);
        return _this;
    }
    TripDetailModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hubName = this.data.hubName;
        this.data.item.hubName = this.hubName;
        var tripId = this.allRouteParams.tripId;
        this.fbLogo = this.imageService.imageSourceUrl(this.fbLogo);
        if (tripId && tripId === 'tour-list') {
            this.data.isShowAddToTripBtn = false;
        }
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.toggle) {
                _this.featuresToggle = command.toggle;
                _this.data.isShowAddToTripBtn = _this.featuresToggle.tripPlanner;
                _this.placeSource = command.dataSource ? command.dataSource.place : _this.data.item.socialName || 'facebook';
            }
            if (command.customSettings) {
                _this.placeImagesShownCount = command.customSettings.placeImagesShownCount;
            }
        });
        if (this.isPlaceInfoNotLoaded) {
            this.getPlaceById(this.data.item.placeId).subscribe(function (data) {
                if (data && data.length) {
                    _this.data.item = data[0];
                    _this.isAccommodation = _this.data.type === 'place' && PlaceService.checkIsAccommodation(_this.data.item);
                    _this.setGooglePlaceInfoAndFBPosts();
                }
            });
        }
        else if (this.isPlaceInfoLoaded) {
            this.isAccommodation = this.data.type === 'place' && PlaceService.checkIsAccommodation(this.data.item);
            this.setGooglePlaceInfoAndFBPosts();
        }
        if (this.isEvent) {
            if (this.isEventNotLoaded) {
                this.getEventById(this.data.item.eventId).subscribe(function (data) {
                    if (data && data.length) {
                        _this.data.item = data[0];
                        _this.processEvent();
                    }
                });
            }
            else {
                this.processEvent();
            }
        }
    };
    Object.defineProperty(TripDetailModalComponent.prototype, "isPlaceInfoNotLoaded", {
        get: function () {
            return !this.data.item.name && this.data.item.placeId && this.data.type === 'place';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripDetailModalComponent.prototype, "isEvent", {
        get: function () {
            return this.data.type === 'event';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripDetailModalComponent.prototype, "isEventNotLoaded", {
        get: function () {
            return !this.data.item.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripDetailModalComponent.prototype, "isPlaceInfoLoaded", {
        get: function () {
            return this.data.type === 'place' && this.data.item.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripDetailModalComponent.prototype, "normalTicketUri", {
        get: function () {
            return this.data.item.ticketUri && (!this.data.item.ticketInfo || this.data.item.ticketInfo.length < 2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripDetailModalComponent.prototype, "processedTicketUri", {
        get: function () {
            var noSchema = this.data.item.ticketUri.replace('https://', '');
            noSchema = noSchema.replace('http://', '');
            noSchema = noSchema.replace('www.', '');
            return noSchema.split('/')[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripDetailModalComponent.prototype, "venueName", {
        get: function () {
            return ((this.data.item.owner && this.data.item.owner.name) ||
                this.data.item.venue ||
                (this.data.item.venueInfo && this.data.item.venueInfo.name));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripDetailModalComponent.prototype, "videoTitle", {
        get: function () {
            var title = '';
            if (this.data.item.youtubeLink) {
                title += 'Youtube Video';
            }
            if (this.data.item._360VideoKey) {
                title += title ? ' & 360° Video' : '360° Video';
            }
            return title;
        },
        enumerable: true,
        configurable: true
    });
    // Youtube video link looks like:
    // https://www.youtube.com/watch?v=puKsjFRwIyw
    // https://www.youtube.com/watch?v=puKsjFRwIyw&t=27s
    TripDetailModalComponent.prototype.getYoutubeLink = function () {
        if (this.data.item.youtubeLink && this.data.item.youtubeLink.includes('watch?v=')) {
            var code = this.data.item.youtubeLink.split('watch?v=')[1].split('&')[0];
            var youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(config.youtubeUrl.replace('${code}', code));
            return youtubeUrl;
        }
        return null;
    };
    TripDetailModalComponent.prototype.get360VideoLink = function () {
        if (this.data.item._360VideoKey) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(config._360VideoUrl.replace('${id}', this.data.item._360VideoKey));
        }
        return null;
    };
    TripDetailModalComponent.prototype.getLink = function (link) {
        if (link && !link.startsWith('http')) {
            return "http://" + link;
        }
        return link;
    };
    TripDetailModalComponent.prototype.openTicketUrl = function (link) {
        window.open(link, '_blank');
    };
    TripDetailModalComponent.prototype.showMoreTimes = function () {
        if (this.trancatedEventTimes.length === 3) {
            this.trancatedEventTimes = this.data.item.eventTimes;
            if (this.data.item.eventTimesText) {
                this.trancatedEventTimesText = this.data.item.eventTimesText;
            }
        }
        else {
            this.trancatedEventTimes = this.data.item.eventTimes.slice(0, 3);
            if (this.data.item.eventTimesText && this.data.item.eventTimesText.length > 3) {
                this.trancatedEventTimesText = this.data.item.eventTimesText.slice(0, 3);
            }
        }
    };
    TripDetailModalComponent.prototype.getTel = function (tel) {
        return 'tel:' + tel;
    };
    TripDetailModalComponent.prototype.visitWebsite = function () {
        if (this.data.item.website || this.data.item.hostLink) {
            window.open(this.data.item.website || this.data.item.hostLink, '_blank');
        }
        else if (this.googleInfo && this.googleInfo.website) {
            window.open(this.googleInfo.website, '_blank');
        }
    };
    TripDetailModalComponent.prototype.buyTicket = function () {
        window.open(this.data.item['ticketUri'], '_blank');
    };
    TripDetailModalComponent.prototype.getDirection = function () {
        var address = this.data.item.address.address || this.data.item.address;
        var url = config.eventShare.googleMapGetDirection.replace('${address}', encodeURIComponent(address.toString()));
        window.open(url, '_blank');
    };
    TripDetailModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    TripDetailModalComponent.prototype.back = function () {
        this.isNotInitLoginStatusChanged = false;
        this.userSelectedToViewFeed = false;
    };
    TripDetailModalComponent.prototype.showEventLink = function () {
        var link = "" + config.serverDomain + this.data.item.hubName + "/event-details/" + this.data.item._id;
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData('Event Link', null, [link], null, true),
                },
            ],
            panelClass: 'width-modal-100p-padding',
        });
    };
    Object.defineProperty(TripDetailModalComponent.prototype, "isShowViewFBPostBtn", {
        get: function () {
            return this.data.type === 'place' && this.data.item.hostLink && this.data.item.hostLink.indexOf('facebook') >= 0;
        },
        enumerable: true,
        configurable: true
    });
    TripDetailModalComponent.prototype.showPlaceFeed = function (socialName) {
        if (socialName === 'facebook') {
            this.isShowFacebookFeed = true;
            this.isShowNearbyPlaces = false;
            this.isShowGoogleFeed = false;
        }
        if (socialName === 'google') {
            this.isShowFacebookFeed = false;
            this.isShowNearbyPlaces = false;
            this.isShowGoogleFeed = true;
        }
        if (socialName === 'nearby') {
            this.isShowFacebookFeed = false;
            this.isShowGoogleFeed = false;
            this.isShowNearbyPlaces = true;
        }
        this.userSelectedToViewFeed = true;
    };
    TripDetailModalComponent.prototype.setGooglePlaceInfoAndFBPosts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.data.item.socialName === 'google')) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, PlaceService.getGooglePlaceDetails(this.data.item, this.hubName, this.visitorApiService)];
                    case 1:
                        _a.googleInfo = _b.sent();
                        if (this.googleInfo) {
                            this.data.item.website = this.googleInfo.website;
                            this.data.item.phone = this.googleInfo.formatted_phone_number || this.googleInfo.phone;
                            this.data.item.hostGoogleLink = this.googleInfo.url || this.googleInfo.hostLink;
                            this.data.item.priceRange = this.googleInfo.price_level;
                            if ((this.googleInfo.reviews && this.googleInfo.reviews.length) ||
                                (this.googleInfo.googleReviews && this.googleInfo.googleReviews.length)) {
                                this.isGoogleFeedLoaded = true;
                            }
                        }
                        this.placePhotos =
                            this.googleInfo.allowedGooglePhotos && this.googleInfo.allowedGooglePhotos.length
                                ? this.googleInfo.allowedGooglePhotos
                                : this.googleInfo.photos || [this.data.item.cover.source];
                        console.log('this.placePhotos', this.placePhotos);
                        this.placePhotos = this.placePhotos.map(function (x) {
                            var isReal = !!(_this.googleInfo.allowedGooglePhotos && _this.googleInfo.allowedGooglePhotos.length);
                            return PlaceService.getGooglePlaceImageFullUrl(x.photo_reference || x, _this.googleInfo.appKey, isReal, false);
                        });
                        console.log('this.placePhotos processed', this.placePhotos);
                        this.placeImagesShownCount = Math.min(this.placeImagesShownCount, this.placePhotos.length);
                        if (isNaN(this.placeImagesShownCount)) {
                            this.placeImagesShownCount = 5;
                        }
                        if (this.data.item['category']) {
                            this.data.item['category'] = PlaceService.allToReadableCategory(this.data.item['category']);
                        }
                        SeoService.createAndInjectGoogleStructureDataScriptForPlace(this.data.item);
                        if (!this.isScriptSolution) {
                            SeoService.addNameIdToUrlForPlaceForNonScriptSolution(this.location, this.data.item, this.dialogRef);
                        }
                        else {
                            // for clients who use the script solution (embed ImGoing as a script into client's website)
                            // change the URL by adding the ImGoing place name + Id to the params so that each place has a unique URL
                            // when close the details modal, reset the URL to the original URL of the host site
                            if (SeoService.getIfNeedToAddNameIdToUrl()) {
                                SeoService.addNameIdToUrlForPlaceForScriptSolution(this.data.item, this.dialogRef);
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.getFacebookPlaceFeed();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TripDetailModalComponent.prototype.gotoPlace = function (item) {
        var _this = this;
        this.back();
        this.data = new TripDetailModalData(item, 'place', this.hubName, null, null, false, null);
        setTimeout(function () {
            _this.imgComp && _this.imgComp.updateImage(_this.data.item.cover && _this.data.item.cover.source);
            _this.imgViewer && _this.imgViewer.updateImage(_this.data.item.cover && _this.data.item.cover.source);
            _this.setGooglePlaceInfoAndFBPosts();
        });
    };
    TripDetailModalComponent.prototype.viewFBPage = function () {
        if (this.data.item.socialName === 'facebook' && this.data.item.hostLink) {
            window.open(this.data.item.hostLink, '_blank');
        }
        if (this.data.item.socialName === 'google' && this.data.item.hostFacebookLink) {
            window.open(this.data.item.hostFacebookLink, '_blank');
        }
    };
    TripDetailModalComponent.prototype.viewFBPost = function () {
        if (!this.isFacebookLoggedIn) {
            this.isNotInitLoginStatusChanged = true;
            this.loginWithFBBtn.login();
        }
        else {
            if (!this.isFBFeedLoaded) {
                // this.getFBPost();
            }
            else {
                this.showPlaceFeed('facebook');
            }
        }
    };
    TripDetailModalComponent.prototype.getFacebookPlaceFeed = function (id) {
        // the FB login status would be triggered once this modal is opened, and this function will be called, but we don't need to load the FB posts now
        if (!this.isNotInitLoginStatusChanged) {
            return;
        }
        // this.getFBPost(id);
    };
    TripDetailModalComponent.prototype.getFBPost = function (id) {
        // // hostFacebookLink is for Google place which is matched with a FB place
        // id = id ? id : ShareService.getFacebookPlaceId(this.data.item.hostLink || this.data.item.hostFacebookLink);
        // this.NoFeed = false;
        // if (id && FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
        //   // this.userSelectedToViewFeed = true;
        //   let url = config.facebook.graphApi.placePosts
        //     .replace('${accessToken}', config.facebook.approvedApps[0])
        //     // .replace('${accessToken}', FacebookLoginButtonComponent.userAccessToken)
        //     .replace('${placeId}', id);
        //   FB.api(url, (response) => {
        //     this.placeFeedPaging = response.paging;
        //     if (!!response.error) {
        //       console.error(response.error);
        //       this.placeFeedPaging = null;
        //       this.NoFeed = true;
        //       this.isFBFeedLoaded = true;
        //       this.showPlaceFeed('facebook');
        //       return;
        //     }
        //     this.updatePlaceFeeds(response.data);
        //   });
        // }
    };
    TripDetailModalComponent.prototype.getNextFacebookPlaceFeed = function (event) {
        var _this = this;
        FB.api(this.placeFeedPaging.next, function (response) {
            event.complete();
            _this.placeFeedPaging = response.paging;
            if (!!response.error) {
                console.error(response.error);
                return;
            }
            _this.updatePlaceFeeds(_this.placeFeeds.concat(response.data));
        });
    };
    TripDetailModalComponent.prototype.updatePlaceFeeds = function (placeFeeds) {
        var _this = this;
        // this.placeFeeds = placeFeeds.filter(x => x.message && x.from && x.actions && x.actions.length >= 2);
        this.placeFeeds = placeFeeds.filter(function (x) { return x.message; });
        this.placeFeeds.forEach(function (x) {
            x.from.link = config.facebook.graphApi.profile.replace('${userId}', x.from.id);
            x.from.picture = config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
        });
        setTimeout(function () {
            _this.isFBFeedLoaded = true;
            if (_this.placeFeeds && _this.placeFeeds.length) {
                //this.onPlaceFeedsRetrieved.emit({item: this.item});
            }
            else {
                _this.NoFeed = true;
            }
            _this.showPlaceFeed('facebook');
        }, 100);
    };
    TripDetailModalComponent.prototype.processEvent = function () {
        this.setEventTimes();
        this.setDescription(this.data.item.description);
        this.setSeoItems();
        if (!this.isScriptSolution) {
            // // change location href, so that there can be a specific url for this place details
            SeoService.addNameIdToUrlForNonScriptSolution(this.location, this.data.item, this.dialogRef);
        }
        else {
            // for clients who use the whole html page solution (we give them a whole page that wraps ImGoing)
            // change the URL by adding the ImGoing event name + Id to the params so that each place has a unique URL
            // when close the details modal, reset the URL to the original URL of the host site
            if (SeoService.getIfNeedToAddNameIdToUrl()) {
                SeoService.addNameIdToUrlForScriptSolution(this.data.item, this.dialogRef);
            }
        }
    };
    TripDetailModalComponent.prototype.setDescription = function (description) {
        var _this = this;
        console.log('set description', description);
        if (description) {
            setTimeout(function () {
                console.log('this.description', _this.description);
                if (_this.description) {
                    _this.description.nativeElement.innerHTML = description;
                }
            }, 100);
        }
        else {
            setTimeout(function () {
                if (_this.description) {
                    _this.description.nativeElement.innerHTML = '';
                }
            }, 100);
        }
    };
    TripDetailModalComponent.prototype.setSeoItems = function () {
        SeoService.createAndInjectGoogleStructureDataScriptForEvent(this.data.item);
    };
    TripDetailModalComponent.prototype.setEventTimes = function () {
        this.isMultiDateEvent = this.data.item.eventTimes && this.data.item.eventTimes.length > 1;
        EventTimeService.processEventTime(this.data.item);
        if (this.data.item.eventTimes && this.data.item.eventTimes.length > 3) {
            this.trancatedEventTimes = this.data.item.eventTimes.slice(0, 3);
        }
        else if (this.data.item.eventTimes && this.data.item.eventTimes.length <= 3) {
            this.trancatedEventTimes = this.data.item.eventTimes.slice(0, this.data.item.eventTimes.length);
        }
        if (this.data.item.eventTimesText && this.data.item.eventTimesText.length > 3) {
            this.trancatedEventTimesText = this.data.item.eventTimesText.slice(0, 3);
        }
        else if (this.data.item.eventTimesText && this.data.item.eventTimesText.length <= 3) {
            this.trancatedEventTimesText = this.data.item.eventTimesText.slice(0, this.data.item.eventTimes.length);
        }
    };
    TripDetailModalComponent.prototype.getPlaceById = function (id) {
        return this.visitorApiService.getPlaces(this.hubName, {
            page: 1,
            limit: 1,
            category: 'All',
            id: id,
        });
    };
    TripDetailModalComponent.prototype.getEventById = function (id) {
        return this.visitorApiService.getEvents(this.hubName, {
            page: 1,
            limit: 1,
            id: id,
        });
    };
    return TripDetailModalComponent;
}(BaseComponent));
export { TripDetailModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.detail.modal/trip.detail.modal.component.ts.pre-build-optimizer.js